import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.css';

export default ({ children, nested }) => (
  <form className={classnames(styles.container, nested && styles.nested)}>
    {children}
  </form>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/form-wrapper/index.js